/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.7 or greater,
	 * jquery.placeholder.min.js,
	 *
	 */

	'use strict';
	/*globals Tc */
	/*jshint smarttabs:true */

	Tc.Module.PageBackground = Tc.Module.extend({

		on: function(callback) {
			var mod = this;
			mod.settingsContainer = $('.scs-stage-flat', mod.$ctx);
			if (mod.settingsContainer.length === 0) {
				mod.settingsContainer = $('<div>').addClass('scs-stage-flat');
				mod.$ctx.prepend(mod.settingsContainer);
			}

			mod.defaultCss = {};
			mod.defaultCss['background-repeat'] = mod.settingsContainer.css('background-repeat');
			mod.defaultCss['background-color'] = mod.settingsContainer.css('background-color');
			mod.defaultCss['background-image'] = mod.settingsContainer.css('background-image');
			mod.defaultFullHeightBackground = mod.settingsContainer.hasClass('full-height-background');

			mod.imageTag = $('.scs-stage-backgroundimage', mod.settingsContainer);
			if (mod.imageTag.length === 0) {
				mod.imageTag = $('<img>').attr('src', '').attr('alt', '').addClass('scs-stage-backgroundimage').addClass('hidden');
				mod.settingsContainer.append(mod.imageTag);
			}
			mod.imageTag.data('default', mod.imageTag.attr('src'));

			mod.$ctx.on('setBackground', $.proxy(mod.setBackground, mod));
			callback();
		},

		setBackground: function(event, image, color, repeatX, repeatY) {
			var mod = this,
				css = {},
				usesRepeat = false;

			if (repeatX && repeatY) {
				css['background-repeat'] = 'repeat';
			} else if (repeatX) {
				css['background-repeat'] = 'repeat-x';
			} else if (repeatY) {
				css['background-repeat'] = 'repeat-y';
			} else if (repeatX === false && repeatY === false) {
				css['background-repeat'] = 'no-repeat';
			} else {
				css['background-repeat'] = mod.defaultCss['background-repeat'];
			}

			if (color) {
				css['background-color'] = color;
			} else {
				css['background-color'] = mod.defaultCss['background-color'];
			}

			if (image) {
				if (css['background-repeat'] === 'no-repeat') {
					mod.imageTag.attr('src', image).removeClass('hidden');
					css['background-image'] = 'none';
				} else {
					css['background-image'] = 'url(' + image + ')';
					mod.imageTag.addClass('hidden');
				}
			} else {
				if (css['background-repeat'] === 'no-repeat' && mod.imageTag.data('default')) {
					mod.imageTag.removeClass('hidden');
				} else {
					mod.imageTag.addClass('hidden');
				}
				mod.imageTag.attr('src', mod.imageTag.data('default'));
				css['background-image'] = mod.defaultCss['background-image'];
			}
			if (!color && !image && !mod.defaultFullHeightBackground) {
				mod.settingsContainer.removeClass('full-height-background');
			} else {
				mod.settingsContainer.addClass('full-height-background');
			}
			mod.settingsContainer.css(css);
		}
	});
	
}(Tc.$));
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.PageBackground.js
// module id = 157
// module chunks = 0